// extracted by mini-css-extract-plugin
export default {"btn":"SubmitButton_btn__0FTmN"};